import React from 'react';
type DecorProps = {
  className?: string;
};

/** Rama botánica con hojas — decorativa. */
export function Sprig({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 200" fill="none" aria-hidden="true" className={className} data-id="element-33" data-mp="et88dp18dbf2">
      <path d="M60 196V16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" data-id="element-34" data-mp="jr9nxzzg6sls" />
      {[0, 1, 2, 3, 4].map(index => {
      const y = 44 + index * 30;
      return <g key={index} data-id="element-35" data-mp="3n8rxcbuvc7ob">
            <path d={`M60 ${y} C40 ${y - 16} 20 ${y - 10} 12 ${y + 6} C30 ${y + 18} 50 ${y + 12} 60 ${y}Z`} fill="currentColor" opacity="0.35" data-id="element-36" data-mp="3n5cfx2dq2mjq" />
            <path d={`M60 ${y + 14} C80 ${y - 2} 100 ${y + 4} 108 ${y + 20} C90 ${y + 32} 70 ${y + 26} 60 ${y + 14}Z`} fill="currentColor" opacity="0.22" data-id="element-37" data-mp="y5ticeeobq4" />
          </g>;
    })}
      <circle cx="60" cy="16" r="7" fill="currentColor" opacity="0.5" data-id="element-38" data-mp="39f0nf2d86ls2" />
    </svg>;
}

/** Flor de cinco pétalos — decorativa. */
export function Blossom({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" className={className} data-id="element-39" data-mp="25ix1gge1npk5">
      {[0, 1, 2, 3, 4].map(index => <ellipse key={index} cx="50" cy="26" rx="14" ry="22" fill="currentColor" opacity="0.4" transform={`rotate(${index * 72} 50 50)`} data-id="element-40" data-mp="20qx5ez13hgsu" />)}
      <circle cx="50" cy="50" r="9" fill="currentColor" opacity="0.75" data-id="element-41" data-mp="1rpfj2yx3givp" />
    </svg>;
}

/** Espiga de lavanda — decorativa. */
export function Lavender({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 60 200" fill="none" aria-hidden="true" className={className} data-id="element-42" data-mp="1hvfdyx1tbdmz">
      <path d="M30 198V78" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" opacity="0.7" data-id="element-43" data-mp="1du3nyqf10qe9" />
      {[0, 1, 2, 3, 4, 5, 6].map(index => {
      const y = 20 + index * 10;
      return <g key={index} opacity={0.55 - index * 0.03} data-id="element-44" data-mp="383xm9qh0rn0d">
            <ellipse cx={30 - 8} cy={y} rx="6" ry="7" fill="currentColor" data-id="element-45" data-mp="15ibnm8535e2j" />
            <ellipse cx={30 + 8} cy={y + 5} rx="6" ry="7" fill="currentColor" data-id="element-46" data-mp="1aamqnjv4hfzb" />
          </g>;
    })}
      <ellipse cx="30" cy="10" rx="6" ry="9" fill="currentColor" opacity="0.6" data-id="element-47" data-mp="wjhly3cwdxi4" />
      <path d="M30 120c-12-6-18-16-18-16 10-2 18 4 18 4Z" fill="currentColor" opacity="0.3" data-id="element-48" data-mp="10k0drxesj3kb" />
      <path d="M30 150c12-6 18-16 18-16-10-2-18 4-18 4Z" fill="currentColor" opacity="0.3" data-id="element-49" data-mp="1oa479by9lmxl" />
    </svg>;
}

/** Frasco gotero de cosmética natural — decorativo. */
export function DropperBottle({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 80 160" fill="none" aria-hidden="true" className={className} data-id="element-50" data-mp="1f8eheak16w1x">
      <rect x="33" y="4" width="14" height="30" rx="4" fill="currentColor" opacity="0.8" data-id="element-51" data-mp="1k77uw2zbin23" />
      <rect x="24" y="30" width="32" height="16" rx="5" fill="currentColor" opacity="0.9" data-id="element-52" data-mp="3trg0hlf61x3" />
      <path d="M26 46h28c6 0 10 5 10 11v82c0 6-4 11-10 11H26c-6 0-10-5-10-11V57c0-6 4-11 10-11Z" fill="currentColor" opacity="0.3" data-id="element-53" data-mp="8tna9p4beezg" />
      <rect x="23" y="82" width="34" height="36" rx="4" fill="currentColor" opacity="0.2" data-id="element-54" data-mp="e6bv0e2omq4" />
      <path d="M40 128c4-7 7-11 7-15a7 7 0 1 0-14 0c0 4 3 8 7 15Z" fill="currentColor" opacity="0.65" data-id="element-55" data-mp="3shywi78gq73m" />
    </svg>;
}

/** Frasco de crema con tapa — decorativo. */
export function CreamJar({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" className={className} data-id="element-56" data-mp="3dqgjmiawgsoh">
      <rect x="18" y="18" width="64" height="16" rx="6" fill="currentColor" opacity="0.85" data-id="element-57" data-mp="38rwyul81lmxp" />
      <path d="M22 34h56c4 0 7 3 7 7v34c0 8-6 14-14 14H29c-8 0-14-6-14-14V41c0-4 3-7 7-7Z" fill="currentColor" opacity="0.3" data-id="element-58" data-mp="3ngt121nf45qe" />
      <rect x="30" y="48" width="40" height="22" rx="4" fill="currentColor" opacity="0.2" data-id="element-59" data-mp="3ipb2tlcs4j94" />
      <path d="M40 60c3-5 7-5 10 0s7 5 10 0" stroke="currentColor" strokeWidth="2.4" opacity="0.55" data-id="element-60" data-mp="2uz78k4lhdvus" />
    </svg>;
}